import React from 'react';

const Label = ({ label, bold, asterisk, id, sublabel, customClass = '' }) => {
  return (
    <div className={sublabel ? "" : bold ? `custom-field-label-bold ${customClass}`:  `custom-field-label ${customClass}`} id={id}>
      {label}
      {asterisk && label && <span className="color-asterisk">{' *'}</span>}
    </div>
  );
};

export default Label;